/**
 * @param {string} className
 * @param {string[]} modifiers
 */
export function populateClassModifiers(className, modifiers) {
  const classes = [className]
  if (modifiers) modifiers.forEach(modifier => classes.push(`${className}--${modifier}`))
  return classes
}
